import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { defaultContent } from "../data/defaultContent";

const SiteContext = createContext({ content: defaultContent, refresh: () => {} });

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(defaultContent);
  const [loaded, setLoaded] = useState(false);

  const fetchContent = useCallback(async () => {
    try {
      const { data } = await api.get(`/site-content`);
      if (data && typeof data === "object") {
        // Deep-merge defaults with received data to be resilient against missing keys.
        setContent({ ...defaultContent, ...data });
      }
    } catch (e) {
      // keep defaults
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  return (
    <SiteContext.Provider value={{ content, loaded, refresh: fetchContent }}>{children}</SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
